import {useGetPatientProtocols} from '@/modules/patients/api/use-get-patient-protocols'
import {useGetPatientTherapies} from '@/modules/patients/api/use-get-patient-therapies'
import {isSequenceBeforeProduction} from '@cypro/engine/utils'
import {useMemo} from 'react'

export function useStopAllTreatmentSummary(patientId: string) {
  const [patientProtocols] = useGetPatientProtocols(patientId)
  const [patientTherapies] = useGetPatientTherapies(patientId)

  return useMemo(() => {
    const activeProtocolIds = new Set(patientProtocols.filter(p => p.endDate == null).map(p => p.id))
    const sequences = patientTherapies.filter(seq => !seq.isNote)

    const individualPrescriptions = sequences.filter(seq => seq.patientProtocolId == null).length
    const prescriptionsToCancel = sequences.filter(
      seq =>
        (seq.patientProtocolId == null || activeProtocolIds.has(seq.patientProtocolId)) &&
        isSequenceBeforeProduction(seq)
    ).length

    return {
      activeProtocols: activeProtocolIds.size,
      individualPrescriptions,
      prescriptionsToCancel,
      hasSomethingToStop: activeProtocolIds.size > 0 || prescriptionsToCancel > 0,
    }
  }, [patientProtocols, patientTherapies])
}
